export default __webpack_public_path__ + "static/media/ParticleFail.920d06ae.jpg";